var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:{
    negative: _vm.isNegative,
    outlined: _vm.outlined,
  },attrs:{"type":_vm.isInputActive ? 'number' : 'text',"readonly":_vm.readonly,"placeholder":_vm.placeholder},domProps:{"value":_vm.displayValue},on:{"blur":_vm.onBlur,"focus":_vm.onFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }